import React from "react";
import classes from "./styles/style.module.css";
import ChevronLeft from "../../../assets/images/icons/chevronLeft.svg";
import { useNavigate } from "react-router";
import useLoginActions from "../../../assets/Hooks/Login";

const ProfileMenuItem = ({ icon, name, action, link }) => {
  const navigate = useNavigate();
  const { handleLogout } = useLoginActions();

  const clickHandler = (action, link) => {
    if (link !== "") {
      if (link.startsWith("https://", 0) || link.startsWith("https://", 0)) {
        window.open(link, "_blank");
      } else {
        navigate(link);
      }
    } else if (action) {
      if (action === "logOut") {
        handleLogout();
      }
    }
  };

  return (
    <div
      className={classes.prorfileMenuContainer}
      onClick={() => clickHandler(action, link)}
    >
      <div className={classes.iconNameContainer}>
        <div className={classes.iconContainer}>
          <img src={icon} alt={name} />
        </div>
        <p>{name}</p>
      </div>
      <div>
        <img src={ChevronLeft} alt="chevron-left-icon" />
      </div>
    </div>
  );
};

export default ProfileMenuItem;
